
import { defineComponent } from "vue";
import { api } from "@/common/api";
import { ElMessage } from "element-plus";
import { BimgxUrlUtil } from "@/common/bimgx-url.util";

export default defineComponent({
    name: "BilibiliCropRequest",
    data() {
        return {
            showDlg: false,
            list: [],
            pagination: {
                page: 1,
                pageSize: 10,
                pageCount: 0,
                withCount: true,
            },
            addForm: {
                video: "",
                needReply: false,
            }
        };
    },

    methods: {
        onGoBack() {
            this.$router.back();
        },

        showAdd() {
            this.addForm.video = "";
            this.addForm.needReply = false;
            
            this.showDlg = true;
        },

        async onAdd() {
            await api.get("/bilibili-crop-request/add", { params: this.addForm });
            this.showDlg = false;

            ElMessage({
                message: "操作成功",
                type: 'success',
            });
        },
    },
});
